import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { invalidateSiteContent } from "@/lib/content";

const inputClass =
  "w-full bg-surface border border-line px-4 py-3 text-sm text-bone focus:border-gold focus:outline-none transition-colors duration-300";

const SECTIONS = [
  {
    title: "Home — Hero",
    fields: [
      { key: "home_hero_title", label: "Titolo principale", long: true },
      { key: "home_hero_sub", label: "Riga sotto il titolo (es. STILL LIFE • ARCHITECTURE…)" },
      { key: "home_hero_cta_work", label: "Pulsante 1" },
      { key: "home_hero_cta_contact", label: "Pulsante 2 (oro)" },
      { key: "home_hero_play", label: "Etichetta play showreel" },
      { key: "home_reel_title", label: "Titolo finestra showreel" },
      { key: "home_reel_duration", label: "Durata mostrata" },
    ],
  },
  {
    title: "Home — Posizionamento",
    fields: [
      { key: "home_pos_label", label: "Etichetta piccola" },
      { key: "home_pos_title", label: "Titolo" },
      { key: "home_pos_text", label: "Paragrafo", long: true },
      { key: "home_pos_caption", label: "Didascalia striscia showreel" },
    ],
  },
  {
    title: "Home — Numeri",
    fields: [
      { key: "home_stat1_v", label: "Numero 1" }, { key: "home_stat1_l", label: "Etichetta 1" },
      { key: "home_stat2_v", label: "Numero 2" }, { key: "home_stat2_l", label: "Etichetta 2" },
      { key: "home_stat3_v", label: "Numero 3" }, { key: "home_stat3_l", label: "Etichetta 3" },
      { key: "home_stat4_v", label: "Numero 4" }, { key: "home_stat4_l", label: "Etichetta 4" },
    ],
  },
  {
    title: "Home — Aree di lavoro",
    fields: [
      { key: "home_areas_label", label: "Etichetta sezione" },
      { key: "home_area1_title", label: "Titolo card 1" },
      { key: "home_area2_title", label: "Titolo card 2" },
      { key: "home_area3_title", label: "Titolo card Motion/AI" },
      { key: "home_area_food_title", label: "Titolo card Food" },
    ],
  },
  {
    title: "Home — Sezione AI",
    fields: [
      { key: "home_ai_label", label: "Etichetta" },
      { key: "home_ai_title", label: "Titolo" },
      { key: "home_ai_text", label: "Paragrafo", long: true },
      { key: "home_ai_cta", label: "Pulsante" },
    ],
  },
  {
    title: "Home — Lavori selezionati e manifesto",
    fields: [
      { key: "home_work_label", label: "Etichetta lavori" },
      { key: "home_work_title", label: "Titolo lavori" },
      { key: "home_work_all", label: "Link vedi tutti" },
      { key: "home_manifesto_label", label: "Etichetta manifesto" },
      { key: "home_manifesto_quote", label: "Citazione manifesto", long: true },
    ],
  },
  {
    title: "Home — Clienti e testimonianze",
    fields: [
      { key: "home_clients_label", label: "Etichetta clienti" },
    ],
  },
  {
    title: "Home — CTA finale",
    fields: [
      { key: "home_cta_title", label: "Titolo" },
      { key: "home_cta_sub", label: "Sottotitolo" },
      { key: "home_cta_button", label: "Pulsante" },
    ],
  },
  {
    title: "Pagina Work",
    fields: [
      { key: "workpage_label", label: "Etichetta" },
      { key: "workpage_title", label: "Titolo" },
      { key: "workpage_intro", label: "Introduzione", long: true },
      { key: "workpage_read", label: "Link leggi caso" },
    ],
  },
  {
    title: "Pagina Product",
    fields: [
      { key: "cat_product_label", label: "Etichetta" },
      { key: "cat_product_title", label: "Titolo" },
      { key: "cat_product_desc", label: "Descrizione", long: true },
      { key: "cat_product_note", label: "Nota piccola" },
    ],
  },
  {
    title: "Pagina Architecture",
    fields: [
      { key: "cat_architecture_label", label: "Etichetta" },
      { key: "cat_architecture_title", label: "Titolo" },
      { key: "cat_architecture_desc", label: "Descrizione", long: true },
      { key: "cat_architecture_note", label: "Nota piccola" },
    ],
  },
  {
    title: "Pagina Food",
    fields: [
      { key: "cat_food_label", label: "Etichetta" },
      { key: "cat_food_title", label: "Titolo" },
      { key: "cat_food_desc", label: "Descrizione", long: true },
      { key: "cat_food_note", label: "Nota piccola" },
    ],
  },
  {
    title: "Pagina Motion / AI / Video",
    fields: [
      { key: "cat_motion_label", label: "Etichetta" },
      { key: "cat_motion_title", label: "Titolo" },
      { key: "cat_motion_desc", label: "Descrizione", long: true },
      { key: "cat_motion_note", label: "Nota piccola" },
    ],
  },
  {
    title: "Pagina About",
    fields: [
      { key: "about_label", label: "Etichetta" },
      { key: "about_title", label: "Titolo" },
      { key: "about_p1", label: "Paragrafo 1", long: true },
      { key: "about_p2", label: "Paragrafo 2", long: true },
      { key: "about_p3", label: "Paragrafo 3", long: true },
      { key: "about_phase1_t", label: "Fase 1 — titolo" }, { key: "about_phase1_x", label: "Fase 1 — testo", long: true },
      { key: "about_phase2_t", label: "Fase 2 — titolo" }, { key: "about_phase2_x", label: "Fase 2 — testo", long: true },
      { key: "about_phase3_t", label: "Fase 3 — titolo" }, { key: "about_phase3_x", label: "Fase 3 — testo", long: true },
      { key: "about_quote", label: "Citazione (acquedotti)" },
      { key: "about_quote_text", label: "Spiegazione citazione", long: true },
      { key: "about_cta_title", label: "CTA finale — titolo", long: true },
      { key: "about_cta_button", label: "CTA finale — pulsante" },
      { key: "about_caption", label: "Didascalia ritratto" },
    ],
  },
  {
    title: "Pagina Contatti",
    fields: [
      { key: "contact_label", label: "Etichetta" },
      { key: "contact_title", label: "Titolo" },
      { key: "contact_intro", label: "Introduzione", long: true },
      { key: "contact_promise", label: "Riga di fiducia sotto il form" },
    ],
  },
  {
    title: "Footer",
    fields: [
      { key: "footer_tagline", label: "Descrizione breve", long: true },
      { key: "footer_rights", label: "Riga copyright" },
      { key: "footer_slogan", label: "Slogan" },
    ],
  },
];

const TextsAdmin = () => {
  const [content, setContent] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/content").then((res) => setContent(res.data)).catch(() => toast.error("Errore nel caricamento"));
  }, []);

  const setText = (key) => (e) =>
    setContent((prev) => ({ ...prev, texts: { ...(prev.texts || {}), [key]: e.target.value } }));

  const handleSave = async () => {
    setSaving(true);
    try {
      await api.put("/admin/content", content);
      invalidateSiteContent();
      toast.success("Testi aggiornati sul sito");
    } catch {
      toast.error("Salvataggio non riuscito");
    } finally {
      setSaving(false);
    }
  };

  if (!content) return <p className="text-xs font-mono tracking-[0.25em] text-fog">CARICAMENTO…</p>;

  const texts = content.texts || {};

  return (
    <div data-testid="admin-texts-page">
      <h1 className="text-2xl font-normal tracking-tight text-bone">Testi del sito</h1>
      <p className="mt-1 text-sm text-fog">Modifica le scritte di ogni pagina. I campi vuoti tornano al testo originale.</p>

      {SECTIONS.map((section) => (
        <section key={section.title} className="mt-10">
          <h2 className="text-xs font-mono tracking-[0.25em] text-gold uppercase border-b border-line pb-3">{section.title}</h2>
          <div className="mt-5 grid md:grid-cols-2 gap-5">
            {section.fields.map((field) => (
              <div key={field.key} className={field.long ? "md:col-span-2" : ""}>
                <label className="block text-[10px] font-mono tracking-[0.2em] text-fog uppercase mb-2">{field.label}</label>
                {field.long ? (
                  <textarea
                    data-testid={`text-field-${field.key}`}
                    rows={3}
                    value={texts[field.key] || ""}
                    onChange={setText(field.key)}
                    className={`${inputClass} resize-none`}
                  />
                ) : (
                  <input
                    data-testid={`text-field-${field.key}`}
                    value={texts[field.key] || ""}
                    onChange={setText(field.key)}
                    className={inputClass}
                  />
                )}
              </div>
            ))}
          </div>
        </section>
      ))}

      <button
        onClick={handleSave}
        data-testid="texts-save-button"
        disabled={saving}
        className="mt-12 px-10 py-4 bg-gold text-night text-xs font-semibold tracking-[0.2em] hover:bg-bone disabled:opacity-60 transition-colors duration-300"
      >
        {saving ? "SALVATAGGIO…" : "SALVA TUTTI I TESTI"}
      </button>
    </div>
  );
};

export default TextsAdmin;
